import classnames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useRouteMatch, withRouter } from "react-router-dom";
import ExamImg from "../../../assets/icons/exam.png";
import HomeImg from "../../../assets/icons/home.png";
import KPIIcon from "../../../assets/icons/KPI.png";
import SchedulerIcon from "../../../assets/icons/scheduler.png";
import SettingImg from "../../../assets/icons/setting.png";
import AttendanceIcon from "../../../assets/icons/user-attendance.png";

export default withRouter(({ className }) => {
	const userPermissions = useSelector((state) => state.session.userPermissions);
	if (!userPermissions) return null;

	return (
		<div>
			<ul
				className={`navbar-nav sidebar sidebar-dark accordion ${
					className ? "" : "toggled"
				} bg-customdark`}
				id="accordionSidebar"
			>
				{/* Nav Item - Dashboard */}

				<MenuLink
					className="nav-item"
					label={
						<>
							<img src={ExamImg} alt="Exam Review" />
							<span>Exam Review</span>
						</>
					}
					to="/exam-ref-list"
				/>

			</ul>
		</div>
	);
});

function MenuLink({ label, to, withPlus = false, ...props }) {
	let match = useRouteMatch({
		path: to,
		exact: props.activeOnlyWhenExact ?? false,
	});

	return (
		<li
			className={
				match ? classnames("active", props.className) : props.className
			}
		>
			<Link className={"nav-link"} to={to}>
				{label}
			</Link>
		</li>
	);
}
